import { SubscriptionsDialogModule } from '@/app/modules/subscriptions/dialogs/subscriptions/subscriptions.component';
import { Injectable, Type } from '@angular/core';
import { DialogNavigations } from '@egovsolutions/angular-dialog-navigations';
import { filter } from 'rxjs/operators';
import { LazyModal } from '../shared/services/lazy-modal.service';

@Injectable({ providedIn: 'any' })
export class SubscriptionsService
{
    constructor
    (
        // Dependencies

        private readonly dialogNavigations: DialogNavigations,
        private readonly lazyModal: LazyModal,
    )
    {
        this.init();
    }


    // Initialization

    public init()
    {
        this.setUpDialogNavigationRequests();
    }


    // Subscriptions

    private subscriptionsComponent?: Type<any>;
    private subscriptionsModule?: typeof SubscriptionsDialogModule;

    private loadSubscriptionsComponent()
    {
        return new Promise<Type<any>>((resolve, reject) =>
        {
            if (!this.subscriptionsComponent)
                import('@/app/modules/subscriptions/dialogs/subscriptions/subscriptions.component').then(dialog =>
                {
                    this.subscriptionsComponent = dialog.SubscriptionsComponent;
                    resolve(this.subscriptionsComponent);
                });
            else
                resolve(this.subscriptionsComponent);
        });
    }

    private loadSubscriptionsModule()
    {
        return new Promise<typeof SubscriptionsDialogModule>((resolve, reject) =>
        {
            if (!this.subscriptionsModule)
                import('@/app/modules/subscriptions/dialogs/subscriptions/subscriptions.component').then(dialog =>
                {
                    this.subscriptionsModule = dialog.SubscriptionsDialogModule;
                    resolve(this.subscriptionsModule);
                });
            else
                resolve(this.subscriptionsModule);
        });
    }

    public showDialog(accountNumber: string)
    {
        const dialogRef = this.lazyModal.open(
            this.loadSubscriptionsComponent,
            this.loadSubscriptionsModule,
            accountNumber,
            { autoFocus: false }
        );

        this.dialogNavigations.set(dialogRef, { type: 'show-subscriptions', data: { accountNumber }});
    }


    // Dialogs navigation

    public setUpDialogNavigationRequests()
    {
        this.dialogNavigations.restore$.pipe(filter(d => d.type === 'show-subscriptions'))
        .subscribe(d => this.showDialog(d.data.accountNumber));
    }
}
